module.exports = __webpack_public_path__ + "img/avatar_2.af4a15ae.jpg";